import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-container show"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"400px","min-height":"300px"}
}
const _hoisted_4 = { class: "modal__content alert text--align-center" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.dialog)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.className)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["alert--icon fa", _ctx.className])
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              innerHTML: _ctx.message,
              class: "alert--message"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = false))
            }, "Close")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}